import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Drawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import { bindActionCreators } from 'redux';

// Portal components
import logoImage from '../../../assets/images/portal-logo.png';

// Actions
import { toggleSidenav } from '../../../actions/layout.actions';

// Styles
import scss from './sidenav.module.scss';

const Sidenav = props => {
    const { theme, layout } = props;
    const [logoImageState, setLogoImageState] = React.useState(logoImage);
    const navigate = useNavigate();

    const getSetting = async () => {
        const profileImageToShow = (await localStorage.getItem('logoUrl')) || logoImage;
        setLogoImageState(profileImageToShow);
    };

    React.useEffect(() => {
        getSetting();
    }, []);

    const sidenavTheme = createTheme(theme.sidenavTheme);
    const dockedClass = layout.sidenavOpen ? scss[`portal-sidenav-${layout.currentLayout}`] : '';

    return (
        <ThemeProvider theme={sidenavTheme}>
            <Drawer
                variant={layout.sidenavVariant}
                open={layout.sidenavOpen}
                onClose={props.toggleSidenav}
                classes={{
                    docked: dockedClass,
                    paper: scss[`portal-sidenav-${layout.currentLayout}`],
                }}
            >
                <AppBar
                    style={{ background: '#424242', borderBottom: '1px solid black' }}
                    color="default"
                    position="static"
                >
                    <Toolbar>
                        <img src={logoImageState} className={scss['portal-toolbar-brand']} alt="logo" />
                        {layout.currentLayout !== 'compact' && layout.currentLayout !== 'funky' && (
                            <Typography variant="h6" color="inherit" noWrap></Typography>
                        )}
                    </Toolbar>
                </AppBar>
                {props.children}
            </Drawer>
        </ThemeProvider>
    );
};

function mapStateToProps(state) {
    return {
        theme: state.theme,
        layout: {
            currentLayout: state.layout.currentLayout,
            sidenavOpen: state.layout.sidenavOpen,
            sidenavVariant: state.layout.sidenavVariant,
        },
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ toggleSidenav }, dispatch);
}

Sidenav.propTypes = {
    toggleSidenav: PropTypes.func.isRequired,
    layout: PropTypes.shape({
        currentLayout: PropTypes.string.isRequired,
        sidenavOpen: PropTypes.bool.isRequired,
        sidenavVariant: PropTypes.string.isRequired,
    }).isRequired,
    theme: PropTypes.shape({
        sidenavTheme: PropTypes.object.isRequired,
    }).isRequired,
    children: PropTypes.node.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidenav);
